import React from 'react';

import _ from 'lodash';
import moment from 'moment';
import { Row, Col, Button, Table, Popover } from 'antd/lib';
import * as Icons from '@ant-design/icons';

class TablaReporteVentas extends React.Component {
  render() {
    const colums = [
      {
        title: 'ID Venta',
        render: venta => (venta._id ? venta._id : venta.id),
      },
      {
        title: 'Usuario Vendedor',
        dataIndex: ['vendedor', 'username'],
      },
      {
        title: 'Nombre Vendedor',
        dataIndex: 'vendedor',
        render: vendedor => vendedor.apellido + ' ' + vendedor.nombre,
      },
      {
        title: 'Fecha',
        dataIndex: 'fecha',
        render: fecha => moment(fecha).format('DD/MM/YYYY HH:mm'),
      },
      {
        title: 'Total',
        dataIndex: 'importe',
        render: text =>
          text.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' }),
      },
      {
        title: 'Tramite',
        dataIndex: 'tramite',
        render: text => (text ? text.toUpperCase() : '-'),
      },
      {
        title: 'Metodo de Pago',
        render: record =>
          record.datosPosnet || (record.pago && record.pago.datosPosnet) ? (
            <Popover
              content={
                <div>
                  <Row>
                    Codigo Operacion:
                    {record.datosPosnet
                      ? ' ' + record.datosPosnet.codigoOperacion
                      : ' ' + record.pago.datosPosnet.codigoOperacion}
                  </Row>
                  <Row>
                    Numero Ticket:
                    {record.datosPosnet
                      ? ' ' + record.datosPosnet.numeroTicket
                      : ' ' + record.pago.datosPosnet.numeroTicket}
                  </Row>
                </div>
              }
              title={`Datos de la Transaccion`}
            >
              POSNET
            </Popover>
          ) : record.datosMercadoPago || record.pago.datosMercadoPago ? (
            <Popover
              content={
                <div>
                  <Row>
                    Numero de Comprobante:
                    {record.datosMercadoPago
                      ? ' ' + record.datosMercadoPago.numeroComprobante
                      : ' ' + record.pago.datosMercadoPago.numeroComprobante}
                  </Row>
                </div>
              }
              title={`Datos de la Transaccion`}
            >
              MERCADO PAGO
            </Popover>
          ) : (
            'EFECTIVO'
          ),
      },
      {
        title: 'Acciones',
        key: 'acciones',
        render: (text, record) => {
          if (
            this.props.usuario.rol === 'SUPERVISOR' ||
            this.props.usuario.rol === 'CONFIGURADOR' ||
            (this.props.usuario.rol === 'FUNCIONARIO' &&
              moment().isSame(record.fecha, 'day'))
          ) {
            return (
              <span>
                <Button
                  size="small"
                  type="danger"
                  icon={<Icons.PrinterOutlined />}
                  onClick={() => {
                    if (record._id) {
                      this.props.eliminarVentaCompleta(record._id, 'MONGO');
                    } else {
                      if (record.id) {
                        this.props.eliminarVentaCompleta(record.id, 'MYSQL');
                      } else {
                        console.error('NO EXISTE LA VENTA EN NINGUNA BASE');
                      }
                    }
                  }}
                >
                  Eliminar
                </Button>
              </span>
            );
          } else {
            return 'SIN ACCIONES PARA SU ROL';
          }
        },
      },
    ];

    return (
      <Table
        bordered
        pagination={false}
        dataSource={this.props.data}
        columns={colums}
        rowKey={venta => (venta._id ? venta._id : venta.id)}
        expandedRowRender={record => {
          let idVenta = record._id ? record._id : record.id;
          if (record.detalle_venta) {
            return _.map(record.detalle_venta.detalle, detalle => {
              return (
                <Row key={idVenta + detalle.tipo_sello._id}>
                  <Col span={4}>
                    <p
                      key={idVenta + detalle.tipo_sello._id}
                      style={{ margin: 0, fontFamily: 'arial', fontSize: 18 }}
                    >
                      {detalle.tipo_sello.nombre + ': ' + detalle.cantidad}
                    </p>
                  </Col>
                </Row>
              );
            });
          } else {
            return _.map(record.detalles, detalle => {
              return (
                <Row key={idVenta + detalle.tipo_sello._id}>
                  <Col span={4}>
                    <p
                      key={idVenta + detalle.tipo_sello._id}
                      style={{ margin: 0, fontFamily: 'arial', fontSize: 18 }}
                    >
                      {detalle.tipo_sello.nombre + ': ' + detalle.cantidad}
                    </p>
                  </Col>
                </Row>
              );
            });
          }
        }}
      />
    );
  }
}

export default TablaReporteVentas;
